import Icon from '../components/Icon';

const Closure = Icon(
  'closure',
  <>
    <path d="M21.25 12a9.25 9.25 0 1 0-18.5 0 9.25 9.25 0 0 0 18.5 0M16 11.25a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5zm6.75.75c0 5.937-4.813 10.75-10.75 10.75S1.25 17.937 1.25 12 6.063 1.25 12 1.25 22.75 6.063 22.75 12" />
  </>
);

export default Closure;
